import BaseButton from "./components/BaseButton.vue";
import BaseCheckbox from "./components/BaseCheckbox.vue";
import BaseRadio from "./components/BaseRadio.vue";
import DropDown from "./components/Dropdown.vue";
import Notify from "./components/NotificationPlugin";

import '@/assets/scss/white-dashboard.scss';
import '@/assets/css/nucleo-icons.css';
import '@/assets/css/custom.css'
import "@/assets/demo/demo.css";
import BaseTable from "@/components/BaseTable";
import ClientView from "@/model/ClientView";
import CallView from "@/model/CallView";
import CallEdit from "@/model/CallEdit";
import BigOne from "@/components/BigOne";
import ClientCallHistory from "@/nestedTables/ClientCallHistory";
import ItemsOption from "@/components/ItemsOption";
import SimpleNameView from "@/model/SimpleNameView";
import SimpleNameEdit from "@/model/SimpleNameEdit";
import BaseTSRView from "@/model/BaseTSRView";
import BaseTSREdit from "@/model/BaseTSREdit";
import CompensationView from "@/model/CompensationView";
import CompensationEdit from "@/model/CompensationEdit";
import ClientIPRs from "@/nestedTables/ClientIPRs";
import IprEdit from "@/model/IprEdit";
import IprView from "@/model/IprView";
import TSRView from "@/model/TSRView";
import TSREdit from "@/model/TSREdit";
import IPRtsrs from "@/nestedTables/IPRtsrs";
import ProductView from "@/model/ProductView";
import ProductEdit from "@/model/ProductEdit";
import ItemView from "@/model/ItemView";
import ItemEdit from "@/model/ItemEdit";
import KitItems from "@/nestedTables/KitItems";
import KitEdit from "@/model/KitEdit";
import KitView from "@/model/KitView";
import TSRKits from "@/nestedTables/TSRKits";
import ClientEdit from "@/model/ClientEdit";
import Files from "@/nestedTables/Files";
import FileView from "@/model/FileView";
import FileEdit from "@/model/FileEdit";
import ClientTSRs from "@/nestedTables/ClientTSRs";
import ListOption from "@/components/ListOption";
import DocumentPatternEdit from "@/model/DocumentPatternEdit";
import DocumentPatternView from "@/model/DocumentPatternView";
import DocumentPatternField from "@/model/DocumentPatternField";
import {BaseInput} from "@/components";
import Documents from "@/nestedTables/Documents";
import DocumentEdit from "@/model/DocumentEdit";
import DocumentView from "@/model/DocumentView";
import ClientContracts from "@/nestedTables/ClientContracts";
import ContractEdit from "@/model/ContractEdit";
import ContractView from "@/model/ContractView";
import IdNameValueSelectModal from "@/components/IdNameValueSelectModal";
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component("base-button", BaseButton);
    Vue.component("base-checkbox", BaseCheckbox);
    Vue.component("base-radio", BaseRadio);
    Vue.component("drop-down", DropDown);
    Vue.component("notify", Notify);
    Vue.component("base-table", BaseTable);
    Vue.component("client-view", ClientView);
    Vue.component("client-edit", ClientEdit)
    Vue.component("call-view", CallView);
    Vue.component("call-edit", CallEdit);
    Vue.component("big-one", BigOne);
    Vue.component("client-call-history", ClientCallHistory);
    Vue.component("items-option", ItemsOption);
    Vue.component("simple-name-view", SimpleNameView);
    Vue.component("simple-name-edit", SimpleNameEdit);
    Vue.component("base-tsr-view", BaseTSRView);
    Vue.component("base-tsr-edit", BaseTSREdit);
    Vue.component("compensation-view", CompensationView);
    Vue.component("compensation-edit", CompensationEdit);
    Vue.component("client-iprs", ClientIPRs);
    Vue.component("ipr-edit", IprEdit);
    Vue.component("ipr-view", IprView);
    Vue.component("tsr-view", TSRView);
    Vue.component("tsr-edit", TSREdit);
    Vue.component("ipr-tsrs", IPRtsrs);
    Vue.component("product-view", ProductView);
    Vue.component("product-edit", ProductEdit);
    Vue.component("item-view", ItemView);
    Vue.component("item-edit", ItemEdit);
    Vue.component("kit-items", KitItems);
    Vue.component("kit-view", KitView);
    Vue.component("kit-edit", KitEdit);
    Vue.component("tsr-kits", TSRKits);
    Vue.component("files", Files);
    Vue.component("file-view", FileView);
    Vue.component("file-edit", FileEdit);
    Vue.component("client-tsrs", ClientTSRs);
    Vue.component("list-option", ListOption);
    Vue.component("doc_pattern-edit", DocumentPatternEdit);
    Vue.component("doc_pattern-view", DocumentPatternView);
    Vue.component("doc_field_pattern", DocumentPatternField);
    Vue.component("base-input", BaseInput);
    Vue.component("documents", Documents);
    Vue.component("doc-edit", DocumentEdit);
    Vue.component("doc-view", DocumentView);
    Vue.component("client-contracts", ClientContracts);
    Vue.component("contract-edit", ContractEdit);
    Vue.component("contract-view", ContractView);
    Vue.component("inv-select-modal", IdNameValueSelectModal)
  }
};

export default GlobalComponents;
